import React from 'react'
import Link from 'gatsby-link'
import headshot from '../images/wes_headshot.jpg';

const SecondPage = ({ data , transition }) => (
  <div style={transition && transition.style}>
  <div className="about_intro">
    <h1 className="pages_head">About Me</h1>
    <img src={headshot} alt="A headshot photo" className='headshot'/>
    <p>
      I'm a professional Developer and Designer who works in the city of Philadelphia. A generalist might be the best way to describe me. Coming up with design and development solutions to problems, figuring out the timeline to execute those solutions, and how to measure success for later iterations is what I do best. This makes me someone who values awareness of the design and development landscape over specialization in any one area.   
      </p>
      <p>
        Work/Life balance is super important to me as well. I maintain healthy hobbies and make sure to invest time and effort into my family and community.  
      </p>
      <p>
        If you're interested in working with me on anything please <Link to="/contact/">contact me</Link>.
      </p>
   </div>   
      <div className="about_page_bottom">
  <div className="home_learning_list">
  <h2>Currently Using for Development &amp; Design</h2>
    <ul>
    {data.allStuffImUsingJson.edges.map(using => (
      <li key={using.node.id}><a target="_blank" rel="nofollow noopener" href={using.node.url}>{using.node.name}</a></li>
    ))}
    </ul>
  </div>
  <div className="about_hobby_list">
  <h2>Interests &amp; Hobbies</h2>
    <ul>
    {data.allInterestsJson.edges.map(using => (
      <li key={using.node.id}>{using.node.name}</li>
    ))}
    </ul>
  </div>

  </div>
 
  </div>
)

export const pageQuery = graphql`
  query aboutAndHobbyQuery {
    allStuffImUsingJson{
      edges {
        node {
          id
          name
          url
        }
      }
    }
    allInterestsJson{
      edges {
        node {
          id
          name
        }
      }
    }
  }
`



export default SecondPage



// WEBPACK FOOTER //
// ./src/pages/about.js